module.exports = __webpack_public_path__ + "static/media/get-into-action.d72fefad.jpg";